export default {
  route: {
    a: 'a',
    b: 'b',
    orderManege: '订单管理',

    infoManege: '信息管理',
    offerManege: '报价管理',
    wasteManege: '废品管理',
    userManege: '用户管理',
    feedbackManege: '反馈管理',
    finance: '财务管理',
    consumption: '消费管理',
    recharge: '充值管理',

    comprehensiveManege: '员工管理',
    collectorManege: '回收员管理',
    permissionsManege: '权限管理',
    pointManege: '站点管理',

    dashboard: '首页',
    client: '客户管理',
    list: '列表管理',
    bd: 'BD管理',
    industry: '业态管理',

    banner:"banner管理",
    bannerList:'banner列表',
    bannerAdd:"banner新增",
    bannerEdit:"banner编辑",
    bannerDetails:"banner详情",
    // weighPricing: '过磅定价',
    // paymentReview: '付款审核',
    // goodsDetail: '收货明细',
    // goodsSummary: '收货汇总',
    // // pricing:'过磅定价',
    // documentation: '文档',
    // test2: '测试2',
    // permission: '测试3',
    //
    // form: '表单',
    // createForm: '创建表单',
    // editForm: '编辑',
    //
    // employeesManagement: '员工管理',
    // userManagement: '用户管理',
    // roleManagement: '角色管理',
    // powerManagement: '权限管理',
    // user: '用户',
    // group: '集团管理',
    // company: '分站管理',
    // param: '参数管理',
    // equipment: '设备审核',
    //
    // suppliersManagement: '供应商管理',
    // productManagement: '废品管理',
    // orderManagement: '入库单管理',
    home: '首页',
  }
}
//
/*
过磅定价
付款审核
收货明细
收货汇总

日付款统计
分站管理
供应商管理
产品管理
库存管理
出库单
出库明细
出库汇总

 */


//



// WEBPACK FOOTER //
// ./src/lang/zh.js